import { createReducer, on } from '@ngrx/store';
import { SearchedPatient } from 'src/app/services/patients.service';
import * as authActions from '../auth/auth.actions';
import * as patientSearchActions from './patient-search.actions';

export interface State {
	queryTerm: string;
	isSearching: boolean;
	searchResults: SearchedPatient[];
	resultsPerAppend: number;
	appendsRetrieved: number;
	lastResultsRetrievedCount: number;
}

export const initialState: State = {
	queryTerm: '',
	isSearching: false,
	searchResults: [],
	resultsPerAppend: 50, // this is a constant value, change this if more results should be displayed per fetch. Be careful setting it too low, if one page doesn't fill the scrollable parent, the infinite scroll will not fire
	appendsRetrieved: 0,
	lastResultsRetrievedCount: 0
}

export const patientSearchReducer = createReducer(
	initialState,
	on(patientSearchActions.newSearchRequested, (state, { queryTerm }) => ({
		...state,
		queryTerm: queryTerm,
		isSearching: true,
		searchResults: [],
		appendsRetrieved: 0,
		lastResultsRetrievedCount: 0
	})),
	on(patientSearchActions.newSearchSucceeded, (state, { searchResults }) => ({
		...state,
		isSearching: false,
		searchResults: searchResults,
		lastResultsRetrievedCount: searchResults.length
	})),
	on(patientSearchActions.newSearchFailed, () => initialState),
	on(patientSearchActions.appendResultsSucceeded, (state, { searchResults }) => ({
		...state,
		searchResults: [...state.searchResults, ...searchResults],
		appendsRetrieved: state.appendsRetrieved + 1,
		lastResultsRetrievedCount: searchResults.length
	})),
	on(patientSearchActions.appendResultsFailed, () => initialState),
	on(patientSearchActions.resultsCleared, () => initialState),
	on(authActions.clearStateRequested, () => initialState)
);